import PersonalInformation from './containers/PersonalInformation';
import { useDispatch, useSelector } from '../../../store/store';
import { selectUserId } from '../../../store/auth/selectors';
import WorkExperience from './containers/WorkExperience';
import UploadedFiles from './containers/UploadedFiles';
import ProfileHeader from './containers/ProfileHeader';
import { AccountTab, AccountTabItem } from './types';
import DropDown from '../../../components/DropDown';
import Identifying from './containers/Identifying';
import ExamStats from './components/ExamStats';
import Education from './containers/Education';
import Expertise from './containers/Expertise';
import { useEffect, useState } from 'react';
import { accountTabs } from './constants';
import styles from './style.module.scss';
import {
    getMatchedJobsThunk,
    getExamsHistoryThunk,
} from '../../../store/workspace/thunks';
import {
    selectMatchedJobs,
    selectExamsHistory,
} from '../../../store/workspace/selectors';

/** The applicant's profile: a summary banner over one tab per group of details. */
function Account() {
    const dispatch = useDispatch();
    const userId = useSelector(selectUserId);
    const jobs = useSelector(selectMatchedJobs);
    const history = useSelector(selectExamsHistory);
    const [tab, setTab] = useState<AccountTab>('Personal');

    useEffect(() => {
        if (!userId) return;
        dispatch(getMatchedJobsThunk(userId));
        dispatch(getExamsHistoryThunk(userId));
    }, [userId]);

    const stats = [
        { title: 'Multiple choice', count: jobs.length },
        { title: 'Coding', count: history.filter(i => i.status === 'codingExam').length },
        { title: 'Interview', count: history.filter(i => i.status === 'interview').length },
    ];

    return (
        <div className={styles.container}>
            <ProfileHeader />
            <ExamStats stats={stats} />

            <div className={styles.body}>
                <div className={styles.tab}>
                    {accountTabs.map(item => <div
                        key={item.id}
                        className={styles.tab_item}
                        onClick={() => setTab(item.id)}
                        data-is-active={tab === item.id}
                    >
                        <span>{item.title}</span>
                    </div>)}
                </div>

                <div className={styles.body_content}>
                    <DropDown
                        idKey='id'
                        titleKey='title'
                        dropDownList={accountTabs}
                        containerClassName={styles.tab_dropdown}
                        setItem={(item: AccountTabItem) => setTab(item.id)}
                        selectedItem={accountTabs.find(item => item.id === tab)}
                    />

                    {tab === 'Personal' && <PersonalInformation />}
                    {tab === 'WorkExperience' && <WorkExperience />}
                    {tab === 'Education' && <Education />}
                    {tab === 'Expertise' && <Expertise />}
                    {tab === 'Files' && <UploadedFiles />}
                    {tab === 'Identify' && <Identifying />}
                </div>
            </div>
        </div>
    );
};

export default Account;
